import React, { ReactNode, useState } from 'react';

import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { FormattedMessage } from '@techstyle/react-intl';

import { trackMembershipLearnMore } from '../../actions/membership';
import {
  CheckoutFeatures,
  MembershipActionLocation,
} from '../../constants/checkout';
import { getIsCartFeatureEnabled } from '../../utils/cart';
import { Component as Price } from '../ExtendedPrice';
import VIPLearnMoreModalComponent from '../VIPLearnMoreModal/VIPLearnMoreModal';

import {
  AddMembershipButton,
  AddMembershipTitleParagraph,
  LearnMoreLink,
  MembershipProductImage,
  PromoParagraph,
  TextContent,
} from './shared';

const VIPLearnMoreModal = VIPLearnMoreModalComponent as any;

const LOCATION = MembershipActionLocation.SHOPPING_BAG;

const Wrapper = styled.div`
  align-items: flex-start;
  display: flex;
  flex-wrap: nowrap;
  margin-bottom: ${props => props.theme.spacing.small}px;

  background-color: ${props => props.theme.colors.lavender250};

  background-color: ${props => props.theme.colors.lavender200};

  ${({ theme }) => theme.context.cartDrawer && `font-size: 12px;`};
`;

const StyledAddMembershipButton = styled(AddMembershipButton)`
  ${({ isNewShoppingBagUX }) =>
    isNewShoppingBagUX && `text-transform: uppercase;`}
`;

const StyledAddMembershipTitleParagraph = styled(AddMembershipTitleParagraph)`
  ${({ isNewShoppingBagUX }) => isNewShoppingBagUX && `font-weight: 400;`}
`;

type JoinVipAnnualProps = {
  className?: string;
  location?: keyof typeof MembershipActionLocation;
  onClick?: () => void;
  isNewProductPricingFlagSet?: boolean;
  isNewShoppingBagUX?: boolean;
  title?: ReactNode;
};

export const JoinVipAnnual: React.FC<JoinVipAnnualProps> = ({
  className,
  location = LOCATION,
  onClick,
  isNewProductPricingFlagSet,
  isNewShoppingBagUX,
  title,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  // @ts-ignore
  const order = useSelector(state => state.checkout);

  const handleOpenModal = () => {
    setIsModalOpen(true);
    trackMembershipLearnMore(location);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const { features = [] } = order ?? {};
  const isRetailPriceTestEnabled = getIsCartFeatureEnabled(
    { features },
    CheckoutFeatures.RETAIL_PRICE_TEST
  );
  const showVipSavings = !isRetailPriceTestEnabled && order.vipSavings;

  return (
    <Wrapper className={className}>
      <MembershipProductImage isNewShoppingBagUX={isNewShoppingBagUX} />
      <TextContent>
        <StyledAddMembershipTitleParagraph
          isNewShoppingBagUX={isNewShoppingBagUX}
        >
          {title ||
            (isNewProductPricingFlagSet ? (
              <FormattedMessage
                id="global_checkout.new_pricing_add_vip_to_cart"
                defaultMessage="Add Membership"
              />
            ) : (
              <FormattedMessage
                id="global_checkout.add_vip_to_cart"
                defaultMessage="Add Savage X Rewards Membership"
              />
            ))}
        </StyledAddMembershipTitleParagraph>
        {showVipSavings && (
          <PromoParagraph>
            <FormattedMessage
              id="global_checkout.save"
              defaultMessage="Save {price} by joining Xtra VIP"
              values={{
                price: <Price amount={order.vipSavings} />,
              }}
            />
          </PromoParagraph>
        )}
        <LearnMoreLink onClick={handleOpenModal}>
          <FormattedMessage
            defaultMessage="Learn more"
            id="global_checkout.join_vip_learn_more_link"
          />
        </LearnMoreLink>
      </TextContent>
      <StyledAddMembershipButton
        onClick={onClick}
        isNewShoppingBagUX={isNewShoppingBagUX}
      >
        <FormattedMessage
          id="global_checkout.add_vip_to_cart_cta"
          defaultMessage="Add"
        />
      </StyledAddMembershipButton>
      <VIPLearnMoreModal isOpen={isModalOpen} onExit={handleCloseModal} />
    </Wrapper>
  );
};
